export default {
  devices: []
};
